import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Cookie from "js-cookie";
import authService from "@/global/service/auth";
import Store from "@/store/index";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes,
});

router.firstInit = false;

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  if (to.meta.title) document.title = to.meta.title;
  const TOKEN = Cookie.get("token");
  try {
    if (!TOKEN) {
      const referer = window.location.href;
      window.location.href =
        "https://account" + process.env.VUE_APP_DOMAIN + "/?referer=" + referer;
      return;
    }
    if (!router.firstInit && TOKEN) {
      router.firstInit = true;
      const userInfo = await authService.info();
      Store.commit("getUserAvatar", userInfo.avatar.path);
      Store.commit("getUserName", userInfo.nickname || userInfo.name);
      const auth = await authService.authPermissions();
      const authPermissions = Object.values(auth.user_permissions);
      if (authPermissions.length !== 0) authPermissions.push("common");
      Store.commit("getAuthPermissions", authPermissions);
    }
    next();
  } catch {
    next();
  }
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
